// ███ THE FIRESTORE DOCUMENT ID MINTER ███
//
// T2 (2026-10-27). A 28-character id over the 62 alphanumerics, which is the
// shape every client-minted document id in this product already had — defined
// byte-identically in two places and about to be defined a third time.
//
// ⚠ EXTRACTED BECAUSE A TEST REFUSED THE THIRD COPY, and that is worth
// recording rather than quietly satisfying. `src/tests/wageRuleKind.test.js`
// enumerates every `customAlphabet(` under `src/` and asserts the SET, with its
// own comment explaining that an allow-list of "files allowed to mint" is how
// the second copy went unnoticed for as long as it did. Adding a fourth entry
// to that list would have been the easy fix and the wrong one: the enumeration
// is not an obstacle, it is the instrument, and it was right.
//
// ⚠ THE ALPHABET AND THE LENGTH ARE A STORED-DATA CONTRACT, NOT A PREFERENCE.
// Ids already in Firestore were minted with exactly these, so neither can be
// changed for existing collections without making old and new ids different
// shapes — which nothing would notice until somebody wrote a validator.
//
// ⚠ NOT `src/utils/ruleId.js`, AND THE SEPARATION IS DELIBERATE. That module
// mints WAGE RULE ids, is 10 characters, and exists to refuse one specific
// sentinel value. A document id and a rule id answer different questions, and
// merging them would put that refusal in the path of every message ever sent.
import { customAlphabet } from 'nanoid';

const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const LENGTH = 28;

export const newDocumentId = customAlphabet(ALPHABET, LENGTH);
export { ALPHABET as DOCUMENT_ID_ALPHABET, LENGTH as DOCUMENT_ID_LENGTH };
